<template>
  <div>
    <b-button variant="outline-light" v-on:click="editDetay()" size="sm" style="padding: 0px;">
      <Icon icon="material-symbols:edit-outline" width="20" height="20" v-b-tooltip.hover.bottom="'DÜZENLE'"
        class="text-warning" />
    </b-button>
    <b-button variant="outline-light" v-on:click="deleteDetay()" size="sm" style="padding: 0px;">
      <Icon icon="material-symbols:delete-outline" width="20" height="20" v-b-tooltip.hover.bottom="'SİL'"
        color="#EA5455" />
    </b-button>
    <b-button variant="outline-light" v-on:click="addStockAct()" size="sm" style="padding: 0px;">
      <Icon icon="ant-design:product-filled" width="20" height="20" v-b-tooltip.hover.bottom="'Stok Hareketi İşlemleri'"
        color="#7367F0" />
    </b-button>


    <!--
    <b-button variant="outline-light" v-on:click="getDetay()" size="sm" style="padding: 0px;">
      <Icon icon="clarity:picture-line" width="20" height="20" v-b-tooltip.hover.bottom="'RESİM'" color="#28C76F" />
    </b-button>
  -->
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  components: {
    Icon
  },
  methods: {
    addStockAct(){
      this.$root.$emit("addStockAct", this.params.data);

    },
    editDetay() {
      this.$root.$emit("addStokList", this.params.data);

    },
    getDetay() {
      this.$root.$emit("getStokResim", this.params.data);
    },
    deleteDetay() {
      this.$root.$emit("deleteEslesenStok", this.params.data);
    },
  }
};
</script>